import styled from '@emotion/styled';
import { ob } from '../../onboardingV2.tokens';

export const Wrap = styled.section`
    margin-top: 18px;
`;

export const Title = styled.h2`
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    font-family: ${ob.font.heading};
    font-size: 15px;
    font-weight: 700;
    color: ${ob.color.text};

    > i {
        font-size: 18px;
        color: ${ob.color.whatsapp};
    }
`;

export const Subtitle = styled.p`
    margin: 4px 0 10px;
    font-size: 13px;
    line-height: 1.4;
    color: ${ob.color.body};
`;

export const Chat = styled.div`
    overflow: hidden;
    border-radius: ${ob.radius.md};
    border: 1px solid ${ob.color.borderSubtle};
    box-shadow: ${ob.shadow.raised};
`;

export const ChatHead = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: ${ob.color.waHeader};
    color: ${ob.color.surface};

    strong {
        display: block;
        font-size: 14px;
        font-weight: 600;
    }

    small {
        display: block;
        font-size: 11.5px;
        opacity: 0.8;
    }
`;

export const Avatar = styled.span`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: ${ob.color.lime200};
    color: ${ob.color.brand};
    font-weight: 700;
`;

export const ChatBody = styled.div`
    padding: 12px 12px 14px;
    background: ${ob.color.waChatBg};
`;

export const Bubble = styled.div`
    position: relative;
    max-width: 92%;
    padding: 8px 10px 20px;
    border-radius: 0 10px 10px 10px;
    background: ${ob.color.waBubble};
    box-shadow: 0 1px 1px rgba(11, 20, 26, 0.13);
    font-size: 13px;
    line-height: 1.35;
    color: ${ob.color.text};
    overflow-wrap: anywhere;
`;

export const Line = styled.div`
    min-height: ${(props) => (props.blank ? '8px' : 'auto')};
    white-space: pre-wrap;
`;

export const Link = styled.span`
    color: ${ob.color.waLink};
    text-decoration: underline;
`;

export const Time = styled.span`
    position: absolute;
    right: 8px;
    bottom: 4px;
    font-size: 10.5px;
    color: ${ob.color.waMeta};
`;
